import { useQuery } from '@tanstack/react-query'

import { GetParametrosProposta } from '@/features/parametros/services'
import { parametrosKeys } from '@/features/parametros/utils/queries'

export const useParametrosProposta = () => {
  return useQuery({
    queryKey: parametrosKeys.proposta(),
    queryFn: async () => new GetParametrosProposta().execute().then((res) => res.data),
  })
}
